import { AbstractSearchFilterTextboxPanel } from "./AbstractSearchFilterTextboxPanel";
import { ChangeEvent } from "../../../../events/ChangeEvent";
import { TextboxVariant } from "../../../textbox/TextboxVariant";

enum InnerIds {
    TEXTBOX_FILTER = "textboxFilter",
    IMAGE_FUNNEL = "imageFunnel",
}

export class FilterTextboxPanel extends AbstractSearchFilterTextboxPanel {
    override syncInnerComponentIds() {
        this.setInnerComponentId(this.textbox, InnerIds.TEXTBOX_FILTER);
        this.setInnerComponentId(this.image, InnerIds.IMAGE_FUNNEL);
    }

    protected override createTextbox() {
        super.createTextbox();
        this.textbox.setProps({
            placeholder: "Filter",
            fontSize: 16,
            captionVisible: false,
            rowBreak: false,
            variant: TextboxVariant.NO_LINES,
            marginBottom: 0,
            clearButtonVisible: this.table.filterClearButtonVisible,
        });
        this.textbox.id = this.createInnerComponentId(InnerIds.TEXTBOX_FILTER);
        this.textbox.addChangeListener((event: ChangeEvent) => this.handleFilterInput(event));
    }

    private handleFilterInput(event: ChangeEvent) {
        this.table.filterValue = event.newValue;
    }

    protected override createImage() {
        super.createImage();
        this.image.setProps({
            name: "funnel",
            color: "#9E9E9E"
        });
        this.image.id = this.createInnerComponentId(InnerIds.IMAGE_FUNNEL);
    }

    override syncFields(visible: boolean, recreateFields: boolean) {
        super.syncFields(visible, recreateFields);
        this.syncVariant();
    }

    override hide() {
        super.hide();
        this.clearTextbox();
        this.textbox.variant = TextboxVariant.NO_LINES;
    }

    clearTextbox() {
        this.textbox.clear();
        this.table._clearFilterValueSilently();
    }

    private syncVariant() {
        // if (this.table.filterAlignment === Alignment.BOTTOM) {
        //     // Display underneath search textbox, with no lines
        //     this.textbox.variant = TextboxVariant.NO_LINES;
        // } else {
            // Display next to search textbox, and show the underline so it matches the search textbox
            this.textbox.variant = TextboxVariant.UNDERLINED;
        // }
    }
}
